export const useUserCapabilities = (): Record<string, boolean> => {
  return {}
}
